import React, { useEffect } from "react";
import { GameClient } from "../gameClient";
import { ExtraMarketButton } from "../styles/ButtonStyle";

/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Sound } from "../../../shared/sound";
import { Colors } from "../palettes/colorPalette";

declare var gameClient: GameClient;

type NextRoundButton = {
	sendInfo: (name: string) => void;
	currentState: string;
	funds: number;
	enabled?: boolean;
}

// Change this and ManualSimulationStart to true to enable the skip button
const uiEnable = true;

export const NextRoundButton = (props: NextRoundButton) => {
	const allowSkip = uiEnable && props.currentState === 'shop'
	const [animate, setAnimate] = React.useState(false);

	useEffect(() => {
		if (props.funds <= 1) {
			setAnimate(true);
		}
	}, [props.funds]);

	const hover = () => {
		if (gameClient) {
			gameClient.playUISound(Sound.Menu)
		}
		props.sendInfo('Continue to the next round!');
	}

	const clear = () => {
		props.sendInfo('');
	}

	const nextRound = () => {
		if (allowSkip) {
			gameClient.playerEndRound();
		}
	};

	return (
		<span css={css`align-self: center;`}>
			<ExtraMarketButton
				tabIndex={-1}
				flash={animate}
				flashColors={[Colors.UIBackground, Colors.UIIncreasedStat]}
				onClick={nextRound}
				position={"round"}
				onMouseEnter={hover}
				onMouseLeave={clear}
				disabled={!props.enabled}
			>
				<FontAwesomeIcon size="2x" icon={faArrowRight} />
				{gameClient.playerHasEndedTurn && gameClient.players.filter(player => !player.isBot).length > 1 &&
					<div style={{ fontSize: '0.8rem' }}>1/2</div>}
			</ExtraMarketButton>
		</span>
	)
}